module.exports = __webpack_public_path__ + "static/media/DK-2069.0c840069.png";